// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0a851b5c","278":"42a6b99c","425":"cd3849ee","456":"6c95e194","543":"ddec0f03","607":"5298715d","658":"917a5245","666":"3fbeb803","731":"ec9a2a15","785":"247128eb","916":"edf2eee6"}[chunkId] + ".chunk.js";
};